module.exports = __webpack_public_path__ + "static/media/17.3d5fb0ef.jpg";